import { Item } from "../../../types"
import { ArtImage } from "../../art-image"
import {
  ArtDetailsContent,
  ArtName,
  ImageContent,
  LeftContent,
  NumberOfArt,
  // Price
} from "./art-details.styled"

export const ArtDetails: React.FC<Item> = ({ name, quantity }) => {
  return <ArtDetailsContent>
    <LeftContent>
      {/* <ImageContent>
        <ArtImage src="asdasd" alt="default image" />
      </ImageContent> */}
      <div>
        <ArtName>{name}</ArtName>
        {/* <NumberOfArt>Quantity: {quantity}</NumberOfArt> */}
      </div>
    </LeftContent>
    {/* Not implemented */}
    {/* <Price>$5,000 COP</Price> */}
  </ArtDetailsContent>
}